import { COLORS } from '@btime/constants'
import { head, propOr } from 'ramda'
import { useFilter, useFilterActions } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import TabsMenu, { Tab } from '../../../../components/tabs/TabsMenu'

const ALL = 'all'
const USAGES = ['serviceOrder', 'form', 'actionPlan']

const FastFilters = () => {
  const { t } = useTranslation()
  const filter = useFilter()
  const { setFilterAndTempFilterValue, clear } = useFilterActions()
  const selectedUsages = propOr([], 'usages', filter)
  let selectedUsage = head(selectedUsages)

  if (selectedUsages.length > 1 || (!!selectedUsage && !USAGES.includes(selectedUsage))) return false

  return (
    <TabsMenu>
      <Tab
        useButtonStyle
        color={!selectedUsage ? COLORS.purple : COLORS.dark3}
        active={!selectedUsage}
        onClick={() => setFilterAndTempFilterValue('usages', [])}
      >
        Todos
      </Tab>

      {USAGES.map(usage => {
        const active = usage === selectedUsage
        return (
          <Tab
            key={usage}
            useButtonStyle
            color={active ? COLORS.purple : COLORS.dark3}
            active={active}
            onClick={() => setFilterAndTempFilterValue('usages', [usage])}
          >
            {t('entity.' + usage)}
          </Tab>
        )
      })}
    </TabsMenu>
  )
}

export default FastFilters
